import React from "react";
import { canAccessRoute } from "../../../routes/routePermissions";
import PageNotFound from "../BaseComponents/PageNotFound/PageNotFound";

export default function PermissionGate({ routePath, children }) {
  if (!canAccessRoute(routePath)) {
    return <PageNotFound />;
  }
  return children;
}
